import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';

const ErrorPage = () => {
  const nav = useNavigate();

  return (
    <div className="flex min-h-screen min-w-[100vw] items-center justify-center overflow-hidden bg-surface-50">
      <div className="flex flex-col items-center justify-center">
        <img
          src="/assets/images/error/logo-error.svg"
          alt="Sakai logo"
          className="mb-8 w-24 shrink-0"
        />
        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, rgba(233, 30, 99, 0.4) 10%, rgba(33, 150, 243, 0) 30%)',
          }}
        >
          <div
            className="smpx-8 flex w-full flex-col items-center bg-surface-0 px-8 py-8"
            style={{ borderRadius: '53px' }}
          >
            <div
              className="flex items-center justify-center rounded-full bg-pink-500"
              style={{ height: '3.2rem', width: '3.2rem' }}
            >
              <i className="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
            </div>
            <h1 className="mb-2 text-5xl font-bold text-surface-900">
              Error Occurred
            </h1>
            <div className="mb-8 text-surface-600">Something went wrong.</div>
            <Button
              icon="pi pi-arrow-left"
              label="Go to Dashboard"
              text
              onClick={() =>
                nav('/main/dashboard', {
                  viewTransition: true,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
